var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BasicSameLocationVideo',{attrs:{"videofullsrc":_vm.videofullsrc,"videoposter":_vm.origin + _vm.videoposter,"videopostermob":_vm.origin + _vm.videopostermob,"playicon":_vm.origin + _vm.playicon,"maidiansuffix":_vm.maidiansuffix}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }